var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 592.22 575.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-49{fill:none;}.cls-2{opacity:0.1;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-13);}.cls-16{fill:url(#linear-gradient-14);}.cls-17{fill:url(#linear-gradient-15);}.cls-18{fill:url(#linear-gradient-16);}.cls-19{fill:url(#linear-gradient-17);}.cls-20{fill:url(#linear-gradient-18);}.cls-21{fill:url(#linear-gradient-19);}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-21);}.cls-24{fill:url(#linear-gradient-22);}.cls-25{fill:url(#linear-gradient-23);}.cls-26{fill:url(#linear-gradient-24);}.cls-27{fill:url(#linear-gradient-25);}.cls-28{fill:#3aedb1;}.cls-29{fill:url(#linear-gradient-26);}.cls-30{fill:url(#linear-gradient-27);}.cls-31{fill:url(#linear-gradient-28);}.cls-32{fill:url(#linear-gradient-29);}.cls-33{fill:url(#linear-gradient-30);}.cls-34{fill:url(#linear-gradient-31);}.cls-35{fill:url(#linear-gradient-32);}.cls-36{fill:url(#linear-gradient-33);}.cls-37{fill:#d3f1ff;}.cls-38{fill:#0a0e17;}.cls-39{fill:url(#linear-gradient-34);}.cls-40{fill:url(#New_Gradient_Swatch_2);}.cls-41{fill:#002b43;}.cls-42,.cls-48{fill:#fd792f;}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#New_Gradient_Swatch_2-2);}.cls-45{fill:url(#linear-gradient-36);}.cls-46{fill:url(#New_Gradient_Swatch_2-3);}.cls-47{fill:url(#New_Gradient_Swatch_2-4);}.cls-48{stroke:#002b43;}.cls-48,.cls-51,.cls-52{stroke-width:2px;}.cls-49{stroke:#e1f9ff;}.cls-50{fill:#e1f9ff;}.cls-51{fill:#dff8ff;stroke:#0f4767;}.cls-52{fill:#031d2c;stroke:url(#New_Gradient_Swatch_2-5);}.cls-53{fill:url(#New_Gradient_Swatch_2-6);}.cls-54{fill:url(#New_Gradient_Swatch_2-7);}.cls-55{fill:url(#New_Gradient_Swatch_2-8);}.cls-56{fill:url(#New_Gradient_Swatch_2-9);}.cls-57{fill:url(#New_Gradient_Swatch_2-10);}.cls-58{fill:url(#New_Gradient_Swatch_2-11);}.cls-59{fill:url(#New_Gradient_Swatch_2-12);}.cls-60{fill:url(#New_Gradient_Swatch_2-13);}.cls-61{fill:url(#linear-gradient-37);}.cls-62{fill:#bceaff;}.cls-63{fill:url(#linear-gradient-38);}.cls-64{clip-path:url(#clip-path);}.cls-65{fill:url(#New_Gradient_Swatch_2-14);}.cls-66{fill:url(#linear-gradient-39);}.cls-67{clip-path:url(#clip-path-2);}.cls-68{fill:url(#linear-gradient-40);}.cls-69{fill:url(#New_Gradient_Swatch_2-15);}.cls-70,.cls-72,.cls-76,.cls-79,.cls-85,.cls-87,.cls-89{fill-opacity:0.5;}.cls-70{fill:url(#New_Gradient_Swatch_3);stroke:url(#New_Gradient_Swatch_2-16);}.cls-71{fill:url(#New_Gradient_Swatch_2-17);}.cls-72{fill:url(#New_Gradient_Swatch_2-18);stroke:url(#New_Gradient_Swatch_2-19);}.cls-73{fill:#f5f5f5;}.cls-74{fill:url(#New_Gradient_Swatch_2-20);}.cls-75{fill:url(#New_Gradient_Swatch_2-21);}.cls-76{fill:url(#New_Gradient_Swatch_3-2);stroke:url(#New_Gradient_Swatch_2-22);}.cls-77{fill:url(#New_Gradient_Swatch_2-23);}.cls-78{fill:url(#New_Gradient_Swatch_2-24);}.cls-79{fill:url(#New_Gradient_Swatch_3-3);stroke:url(#New_Gradient_Swatch_2-25);}.cls-80{fill:url(#New_Gradient_Swatch_2-26);}.cls-81{fill:url(#New_Gradient_Swatch_2-27);}.cls-82{fill:url(#New_Gradient_Swatch_2-28);}.cls-83{fill:url(#New_Gradient_Swatch_2-29);}.cls-84{fill:url(#New_Gradient_Swatch_2-30);}.cls-85{fill:url(#New_Gradient_Swatch_3-4);stroke:url(#New_Gradient_Swatch_2-31);}.cls-86{fill:url(#New_Gradient_Swatch_2-32);}.cls-87{fill:url(#radial-gradient);stroke:url(#New_Gradient_Swatch_2-33);}.cls-88{fill:url(#New_Gradient_Swatch_2-34);}.cls-89{fill:url(#New_Gradient_Swatch_2-35);stroke:url(#New_Gradient_Swatch_2-36);}.cls-90{fill:url(#New_Gradient_Swatch_2-37);}.cls-91{fill:url(#New_Gradient_Swatch_2-38);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 174.49,
    y1: 147.92,
    x2: 356.7,
    y2: -594.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bd9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 281.48,
    y1: 174.16,
    x2: 463.68,
    y2: -568.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 384.84,
    y1: 131.5,
    x2: 207.34,
    y2: -612.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 38.36,
    y1: -11.15,
    x2: 626.47,
    y2: -499.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 340.27,
    y1: 220.82,
    x2: 451.43,
    y2: -208.93,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04c283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0461c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 351.93,
    y1: 223.84,
    x2: 463.1,
    y2: -205.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 371.62,
    y1: 196.29,
    x2: 553.83,
    y2: -546.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 260.44,
    y1: 169.01,
    x2: 442.65,
    y2: -573.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 133.31,
    y1: 137.81,
    x2: 315.51,
    y2: -604.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 335.53,
    y1: 187.43,
    x2: 517.74,
    y2: -555.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 181.23,
    y1: 149.57,
    x2: 363.43,
    y2: -592.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 63.09,
    y1: -22.2,
    x2: 750.03,
    y2: -357.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 300.9,
    y1: 178.93,
    x2: 483.1,
    y2: -563.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 527.93,
    y1: -14.79,
    x2: -159.5,
    y2: -349.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 387.58,
    y1: 200.2,
    x2: 569.78,
    y2: -542.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 164.94,
    y1: 145.57,
    x2: 347.15,
    y2: -596.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 237.07,
    y1: 163.29,
    x2: 419.28,
    y2: -579.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 373.53,
    y1: 196.75,
    x2: 555.74,
    y2: -545.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 537.15,
    y1: -156.22,
    x2: -219.59,
    y2: -265.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 416.16,
    y1: 207.22,
    x2: 598.37,
    y2: -535.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 382.7,
    y1: 231.8,
    x2: 493.87,
    y2: -197.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 373.77,
    y1: 229.49,
    x2: 484.94,
    y2: -200.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#059acc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0461c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 355.99,
    y1: 224.89,
    x2: 467.15,
    y2: -204.87,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 329.52,
    y1: 218.05,
    x2: 440.68,
    y2: -211.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 411.14,
    y1: 239.16,
    x2: 522.3,
    y2: -190.6,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 403.59,
    y1: 237.21,
    x2: 514.76,
    y2: -192.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 431.12,
    y1: 244.33,
    x2: 542.28,
    y2: -185.44,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 408.82,
    y1: 238.56,
    x2: 519.99,
    y2: -191.21,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 432.83,
    y1: 244.77,
    x2: 543.99,
    y2: -185,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 358.03,
    y1: 192.95,
    x2: 540.24,
    y2: -549.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 52.48,
    y1: 44.5,
    x2: 931.79,
    y2: 84.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 255.77,
    y1: 167.86,
    x2: 437.98,
    y2: -574.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 72.06,
    y1: -96.34,
    x2: 828.61,
    y2: 14.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 286.19,
    y1: 102.64,
    x2: 293.73,
    y2: 27.22,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3aedb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 228.45,
    y1: 248.72,
    x2: 361.33,
    y2: 248.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f64104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 204.17,
    y1: 54.48,
    x2: 211.31,
    y2: 21.05,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 209.93,
    y1: 54.88,
    x2: 214.34,
    y2: -5.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 360.43,
    y1: 16.84,
    x2: 373.71,
    y2: 13.98,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 360.52,
    y1: 17.19,
    x2: 384.08,
    y2: 11.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 294.84,
    y1: 60.75,
    x2: 294.93,
    y2: 91.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 272.47,
    y1: 370.79,
    x2: 317.33,
    y2: 370.79,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-6",
    x1: 286.22,
    y1: 362.88,
    x2: 288.41,
    y2: 362.88,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    x1: 296.65,
    y1: 368.29,
    x2: 301.5,
    y2: 368.29,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-8",
    x1: 298.17,
    y1: 369.89,
    x2: 305.18,
    y2: 369.89,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-9",
    x1: 297.07,
    y1: 361.99,
    x2: 299.27,
    y2: 361.99,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-10",
    x1: 281.31,
    y1: 369.05,
    x2: 287.85,
    y2: 369.05,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-11",
    x1: 286.53,
    y1: 386.18,
    x2: 288.72,
    y2: 386.18,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-12",
    x1: 288.27,
    y1: 373.06,
    x2: 297.39,
    y2: 373.06,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-13",
    x1: 303.66,
    y1: 360.89,
    x2: 308.48,
    y2: 360.89,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 399.71,
    y1: -73.79,
    x2: 375.18,
    y2: -87.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bababa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 412.63,
    y1: -146,
    x2: 384,
    y2: -136.56,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 353.96,
    y: 415.11,
    width: 40.82,
    height: 10.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-14",
    x1: 374.97,
    y1: -150,
    x2: 372.38,
    y2: -197.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 129.15,
    y1: -12.59,
    x2: 157.18,
    y2: -1.72,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.38,
    y: 228.77,
    width: 32.83,
    height: 15.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 128.68,
    y1: 84.28,
    x2: 128.68,
    y2: 51.38,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-15",
    x1: 131.74,
    y1: 84.01,
    x2: 126.65,
    y2: 25.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_3",
    cx: -1475.72,
    cy: 645.75,
    r: 0.41,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -32703.72, 132586.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd792f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd792f",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-16",
    x1: 548.63,
    y1: 9.8,
    x2: 560.88,
    y2: -105.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-17",
    x1: 540.27,
    y1: 324.67,
    x2: 572.97,
    y2: 324.67,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-18",
    x1: -1476.13,
    y1: 645.75,
    x2: -1475.3,
    y2: 645.75,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -32757.72, 132368.71)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-19",
    x1: 494.63,
    y1: 227.8,
    x2: 506.88,
    y2: 112.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-20",
    x1: 493.25,
    y1: 98.88,
    x2: 501.19,
    y2: 98.88,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-21",
    x1: 485.55,
    y1: 105.55,
    x2: 518.88,
    y2: 105.55,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_3-2",
    cx: -1475.84,
    cy: 645.69,
    r: 1,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -33183.72, 132376.71)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-22",
    x1: 68.63,
    y1: 219.8,
    x2: 80.88,
    y2: 104.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-23",
    x1: 60.33,
    y1: 119.83,
    x2: 82.98,
    y2: 119.83,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-24",
    x1: 65.33,
    y1: 108.67,
    x2: 93.67,
    y2: 108.67,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_3-3",
    cx: -1475.72,
    cy: 645.75,
    r: 0.41,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -33142.72, 132802.71)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-25",
    x1: 109.63,
    y1: -206.2,
    x2: 121.88,
    y2: -321.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-26",
    x1: 108.56,
    y1: 544.52,
    x2: 126.71,
    y2: 544.52,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-27",
    x1: 109.28,
    y1: 523.69,
    x2: 114.2,
    y2: 523.69,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-28",
    x1: 121.07,
    y1: 523.68,
    x2: 126,
    y2: 523.68,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-29",
    x1: 102,
    y1: 528.89,
    x2: 108.29,
    y2: 528.89,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-30",
    x1: 126.97,
    y1: 528.89,
    x2: 133.27,
    y2: 528.89,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_3-4",
    cx: -1475.84,
    cy: 645.69,
    r: 1,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -32790.72, 132802.71)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-31",
    x1: 461.63,
    y1: -206.2,
    x2: 473.88,
    y2: -321.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-32",
    x1: 453.33,
    y1: 540.01,
    x2: 486.67,
    y2: 540.01,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 227.64,
    cy: 7.27,
    r: 0.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd792f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd792f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-33",
    x1: 274.63,
    y1: 297.8,
    x2: 286.88,
    y2: 182.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-34",
    x1: 264,
    y1: 36,
    x2: 301.78,
    y2: 36,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-35",
    x1: -1476.13,
    y1: 645.75,
    x2: -1475.3,
    y2: 645.75,
    gradientTransform: "matrix(14, 83.5, 83.5, -14, -33224.72, 132587.71)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-36",
    x1: 27.63,
    y1: 8.8,
    x2: 39.88,
    y2: -106.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 258.28)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-37",
    x1: 17.67,
    y1: 335,
    x2: 34.33,
    y2: 335,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-38",
    x1: 19.33,
    y1: 324.18,
    x2: 52.67,
    y2: 324.18,
    xlinkHref: "#New_Gradient_Swatch_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.09,465.7v0a3.92,3.92,0,0,0,.35,3.07,3.82,3.82,0,0,0,1,1.19,3.92,3.92,0,0,0,1.41.68c2.88.7,5.77,1.34,8.69,1.9a4.1,4.1,0,0,0,4.77-3.27v-.05a3.76,3.76,0,0,0,0-1.53,3.84,3.84,0,0,0-.59-1.4,3.91,3.91,0,0,0-2.5-1.64c-2.8-.53-5.56-1.13-8.31-1.82a4.08,4.08,0,0,0-3,.44A4.14,4.14,0,0,0,254.09,465.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393.47,442.79a165.25,165.25,0,0,0,51-62.59,3.87,3.87,0,0,0,.37-1.53,4.07,4.07,0,0,0-.25-1.55,4,4,0,0,0-.85-1.33,3.84,3.84,0,0,0-1.3-.88h0a4.07,4.07,0,0,0-5.25,2.08,156.75,156.75,0,0,1-147.57,90.27,4.11,4.11,0,0,0-4.25,3.72v0a4.1,4.1,0,0,0,.18,1.56,3.81,3.81,0,0,0,.78,1.37,3.84,3.84,0,0,0,2.77,1.32A163.72,163.72,0,0,0,393.47,442.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.43,497a165.2,165.2,0,0,0,74-32.33,3.88,3.88,0,0,0,1.51-2.68,4,4,0,0,0-.14-1.57,4.13,4.13,0,0,0-.75-1.38l0,0a4.09,4.09,0,0,0-5.62-.55,156.75,156.75,0,0,1-172.51,12.81,4.06,4.06,0,0,0-3-.41,4.12,4.12,0,0,0-2.48,1.78l0,0a4,4,0,0,0-.49,3,3.9,3.9,0,0,0,1.86,2.44A163.72,163.72,0,0,0,320.43,497Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.67,319.07a4,4,0,0,1,1.19-2.87,4.06,4.06,0,0,1,2.87-1.19h.05a3.88,3.88,0,0,1,1.5.28,3.94,3.94,0,0,1,1.29.84,3.87,3.87,0,0,1,.86,1.26,3.67,3.67,0,0,1,.32,1.5A149.09,149.09,0,0,0,239.7,455.76a4.18,4.18,0,0,1,1.3.81,3.92,3.92,0,0,1,.89,1.25,4.06,4.06,0,0,1,.35,1.49,4.1,4.1,0,0,1-.26,1.51l0,0a4.06,4.06,0,0,1-2.14,2.26,4.11,4.11,0,0,1-3.12.1,156.94,156.94,0,0,1-101-144.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.85,410.51a.36.36,0,0,0,.14.11.32.32,0,0,0,.16,0,.33.33,0,0,0,.17,0,.36.36,0,0,0,.14-.11,165.18,165.18,0,0,0,10.93-16.28.39.39,0,0,0,0-.26.42.42,0,0,0-.14-.24.52.52,0,0,0-.15-.07.43.43,0,0,0-.16,0,.35.35,0,0,0-.14.06.43.43,0,0,0-.11.12,164.92,164.92,0,0,1-10.88,16.21.4.4,0,0,0-.08.23A.36.36,0,0,0,428.85,410.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M442.12,390.23a.37.37,0,0,0,.15.08.33.33,0,0,0,.17,0,.44.44,0,0,0,.16-.06.45.45,0,0,0,.11-.13c.7-1.26,1.38-2.53,2-3.82a.39.39,0,0,0,0-.26.37.37,0,0,0-.14-.22.34.34,0,0,0-.15-.07h-.16a.35.35,0,0,0-.15.07.41.41,0,0,0-.1.13c-.66,1.27-1.34,2.54-2,3.8a.36.36,0,0,0-.05.25A.48.48,0,0,0,442.12,390.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M373.7,171.21a4.08,4.08,0,0,0-5.43,1.88l0,0a4.08,4.08,0,0,0-.4,1.48,3.91,3.91,0,0,0,.19,1.52,3.84,3.84,0,0,0,.76,1.33,3.66,3.66,0,0,0,1.2.94,149.12,149.12,0,0,1,81.14,146.15,3.91,3.91,0,0,0,.16,1.52,3.85,3.85,0,0,0,.73,1.35,3.94,3.94,0,0,0,1.19,1,3.78,3.78,0,0,0,1.47.43h0a4.08,4.08,0,0,0,4.42-3.7,156.91,156.91,0,0,0-85.45-153.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M215.8,188.35a154.66,154.66,0,0,1,132.46-18.83,4.09,4.09,0,0,0,5.06-2.49v0a4,4,0,0,0,.25-1.56,3.79,3.79,0,0,0-.38-1.52,3.92,3.92,0,0,0-.95-1.26,3.88,3.88,0,0,0-1.37-.77,161.88,161.88,0,0,0-70.6-6.21,164.48,164.48,0,0,0-68.91,26,3.86,3.86,0,0,0-1.12,1.12,3.92,3.92,0,0,0-.61,1.46,3.87,3.87,0,0,0,0,1.59,4.11,4.11,0,0,0,.62,1.46l0,0a4,4,0,0,0,5.52,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M192.59,201.67a4.24,4.24,0,0,0-1.3-.91,4.05,4.05,0,0,0-1.54-.33,3.92,3.92,0,0,0-1.55.29,4.09,4.09,0,0,0-1.33.87,163.73,163.73,0,0,0-48.38,101.66,4,4,0,0,0,.17,1.57,4.06,4.06,0,0,0,.78,1.37,4,4,0,0,0,2.79,1.32h0a4.13,4.13,0,0,0,2.87-1,4.06,4.06,0,0,0,1.38-2.71,154.83,154.83,0,0,1,45.91-96.5,3.94,3.94,0,0,0,1.23-2.75,4,4,0,0,0-1-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M365.84,145.54a181.91,181.91,0,0,0-77.93-11.18,4,4,0,0,0-2.78,1.41,4.14,4.14,0,0,0-1,3v.05a4,4,0,0,0,.43,1.47,3.83,3.83,0,0,0,.95,1.2,3.68,3.68,0,0,0,1.34.74,3.72,3.72,0,0,0,1.52.17c52-3.94,103,15.82,138.06,53.43a4,4,0,0,0,5.61.21l0,0a3.91,3.91,0,0,0,1-1.25,4,4,0,0,0,.41-1.52,4.21,4.21,0,0,0-.22-1.57,3.93,3.93,0,0,0-.8-1.35A177.25,177.25,0,0,0,365.84,145.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M138.72,232.54a4,4,0,0,0-.45,1.51,4.18,4.18,0,0,0,.18,1.57,3.9,3.9,0,0,0,.78,1.37,4,4,0,0,0,1.24.95l.05,0a4,4,0,0,0,3,.17,4.1,4.1,0,0,0,2.31-2,177.67,177.67,0,0,1,114.43-89.32,4.05,4.05,0,0,0,2.47-1.75,4.1,4.1,0,0,0,.58-3V142a4,4,0,0,0-1.75-2.53,4,4,0,0,0-1.47-.56,3.91,3.91,0,0,0-1.56.07,186,186,0,0,0-119.83,93.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M131,392.43a3.89,3.89,0,0,0,2.18,2.18,3.77,3.77,0,0,0,1.55.28,3.83,3.83,0,0,0,1.53-.34l.05,0a4.06,4.06,0,0,0,2-5.26A177.75,177.75,0,0,1,143,244.19a4.08,4.08,0,0,0,.24-3,4,4,0,0,0-1.92-2.35l0,0a3.84,3.84,0,0,0-1.51-.46,3.78,3.78,0,0,0-1.56.18,3.91,3.91,0,0,0-2.31,2A185.9,185.9,0,0,0,131,392.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M426.77,435.05l0,0a4,4,0,0,0-5.6.17,179,179,0,0,1-58.87,39.5,4.06,4.06,0,0,0-2.19,2.1,4.1,4.1,0,0,0-.12,3v0a3.83,3.83,0,0,0,.83,1.33,4,4,0,0,0,1.29.9,4.09,4.09,0,0,0,1.54.33,3.89,3.89,0,0,0,1.54-.31,186.21,186.21,0,0,0,40.45-22.94,188.84,188.84,0,0,0,21.22-18.44,4.11,4.11,0,0,0,.87-1.31,4.07,4.07,0,0,0,0-3.09A4.11,4.11,0,0,0,426.77,435.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M206.77,471.12l0,0a4,4,0,0,0-1.34-5.44,178.92,178.92,0,0,1-51-49.21,4.07,4.07,0,0,0-5.52-1.18h0a4,4,0,0,0-1.13,1.09,4.31,4.31,0,0,0-.61,1.45,4.14,4.14,0,0,0,0,1.57,3.8,3.8,0,0,0,.63,1.44,185.78,185.78,0,0,0,30.95,34.71,188.4,188.4,0,0,0,22.5,16.85,3.9,3.9,0,0,0,1.47.58,4,4,0,0,0,1.57,0,4.24,4.24,0,0,0,1.44-.64A4,4,0,0,0,206.77,471.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M440.3,412.21a4,4,0,0,0,.87,5.51l0,0a4.24,4.24,0,0,0,1.44.64,4,4,0,0,0,1.58,0,4.13,4.13,0,0,0,1.48-.58,4,4,0,0,0,1.14-1.09,183.37,183.37,0,0,0,32.81-93.31,177.89,177.89,0,0,0-21.15-96.91,4,4,0,0,0-1-1.2,4.14,4.14,0,0,0-1.41-.7,4,4,0,0,0-1.57-.09,3.91,3.91,0,0,0-1.48.52l0,0a4,4,0,0,0-1.55,5.4C482.48,287.6,478.16,358.08,440.3,412.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M168.09,168.81a4,4,0,0,0,5.62.3c3.51-3,7.13-5.9,10.83-8.66l.5-.37a4.27,4.27,0,0,0,1.09-1.15,3.9,3.9,0,0,0,.55-1.48,4,4,0,0,0-.05-1.58,4.07,4.07,0,0,0-.67-1.43,3.91,3.91,0,0,0-1.16-1.06,3.92,3.92,0,0,0-3.06-.43,4.05,4.05,0,0,0-1.41.7l-.53.4c-3.85,2.87-7.64,5.9-11.29,9a4,4,0,0,0-1,1.24,4.06,4.06,0,0,0-.42,1.53,4.16,4.16,0,0,0,.19,1.57A3.9,3.9,0,0,0,168.09,168.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M390.13,488.41a3.94,3.94,0,0,0-5.33-1.63A194.49,194.49,0,0,1,287.16,508a4.11,4.11,0,0,0-4.26,3.73v0a4.1,4.1,0,0,0,.18,1.56,4,4,0,0,0,.77,1.37,4.15,4.15,0,0,0,1.25,1,4.2,4.2,0,0,0,1.52.38A202.74,202.74,0,0,0,388.39,493.9a4.2,4.2,0,0,0,1.24-1,4.26,4.26,0,0,0,.77-1.38,4.18,4.18,0,0,0,.18-1.57,4.23,4.23,0,0,0-.44-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M496.27,315.64h0a4.08,4.08,0,0,0-4.07,3.92C489.81,379,461.12,433.34,413,469.2l-.26.2a4,4,0,0,0-1.6,2.57,4,4,0,0,0,.65,3l0,0A4,4,0,0,0,413,476a3.88,3.88,0,0,0,1.48.54,4,4,0,0,0,1.57-.08,4.05,4.05,0,0,0,1.42-.68l.29-.22a204.48,204.48,0,0,0,82.44-155.9,3.94,3.94,0,0,0-1.1-2.87,3.76,3.76,0,0,0-1.28-.88A3.88,3.88,0,0,0,496.27,315.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M272.32,512v-.05a4.05,4.05,0,0,0-.86-2.92,4.09,4.09,0,0,0-2.64-1.52c-58.92-8.09-110.23-41.92-141.25-93.3a2.61,2.61,0,0,0-.17-.28,4,4,0,0,0-2.4-1.84,4,4,0,0,0-3,.36l0,0a4.09,4.09,0,0,0-1.18,1.05,4,4,0,0,0-.68,1.42,3.78,3.78,0,0,0-.07,1.57,3.88,3.88,0,0,0,.54,1.48l.18.31A204.43,204.43,0,0,0,267.9,515.47a3.91,3.91,0,0,0,1.56-.1,3.91,3.91,0,0,0,2.4-1.9A3.92,3.92,0,0,0,272.32,512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M461.47,193.55a197.41,197.41,0,0,0-38.77-39.44,4.1,4.1,0,0,0-1.43-.68,4,4,0,0,0-1.58-.07,3.93,3.93,0,0,0-1.49.54A4,4,0,0,0,417,155l0,0a4,4,0,0,0,.73,5.52,190.43,190.43,0,0,1,73.8,134.12,4,4,0,0,0,.43,1.48,4.09,4.09,0,0,0,1,1.19,3.85,3.85,0,0,0,1.35.73,3.71,3.71,0,0,0,1.52.16h0a4.08,4.08,0,0,0,3.71-4.4A197.82,197.82,0,0,0,461.47,193.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M422.77,177c-.15,0-.1,0,.12-.09l.27-.15c-1.06-.93-2.13-1.86-3.21-2.77h0c-.11.09-.21.19-.31.29a2.53,2.53,0,0,0-.23.26c1,.86,2,1.73,3,2.61A3.13,3.13,0,0,1,422.77,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M416.65,171.83l0,0a.26.26,0,0,0,.08-.13.25.25,0,0,0,0-.15.37.37,0,0,0,0-.14.52.52,0,0,0-.1-.11q-6.76-5.4-14-10.14a.34.34,0,0,0-.14,0,.38.38,0,0,0-.15,0,.27.27,0,0,0-.13.07.52.52,0,0,0-.1.11l0,.05a.34.34,0,0,0,0,.26.36.36,0,0,0,.16.22q7.23,4.69,14,10.09a.34.34,0,0,0,.12.06.32.32,0,0,0,.14,0l.13,0A.28.28,0,0,0,416.65,171.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M375.2,147.38a175.67,175.67,0,0,1,23.12,12l.13.05a.38.38,0,0,0,.15,0,.33.33,0,0,0,.13-.07.31.31,0,0,0,.09-.11l0-.05a.32.32,0,0,0,0-.27.36.36,0,0,0-.16-.21,178.88,178.88,0,0,0-23.21-12l-.15,0a.35.35,0,0,0-.14,0l-.12.09a.36.36,0,0,0-.08.12.57.57,0,0,0,0,.14.4.4,0,0,0,0,.15.2.2,0,0,0,.08.12A.34.34,0,0,0,375.2,147.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M435.56,188.79q-4.44-4.75-9.23-9.19a.33.33,0,0,0-.21-.09.37.37,0,0,0-.23.05l0,0a.43.43,0,0,0-.12.11.3.3,0,0,0-.05.16.29.29,0,0,0,0,.16.28.28,0,0,0,.1.14q4.77,4.41,9.2,9.16a3.51,3.51,0,0,1,.72,1.18,3.41,3.41,0,0,1,.2,1.38,3.57,3.57,0,0,1-1.24,2.58l0,0a3.61,3.61,0,0,1-5.06-.19,170.23,170.23,0,0,0-62.82-42.38,174.07,174.07,0,0,0-75.56-11.16,3.53,3.53,0,0,1-1.37-.15,3.54,3.54,0,0,1-2.07-1.75,3.48,3.48,0,0,1-.37-1.33v-.05a3.6,3.6,0,0,1,.17-1.42,3.76,3.76,0,0,1,.7-1.25,3.66,3.66,0,0,1,1.13-.9,3.75,3.75,0,0,1,1.39-.39,182,182,0,0,1,77.78,11.16c.82.31,1.64.64,2.45,1a.39.39,0,0,0,.15,0,.32.32,0,0,0,.14,0,.47.47,0,0,0,.12-.09.54.54,0,0,0,.07-.13v0a.36.36,0,0,0,0-.27.31.31,0,0,0-.19-.18c-.82-.33-1.64-.66-2.45-1a182.73,182.73,0,0,0-78.11-11.21,4.45,4.45,0,0,0-3,1.55,4.5,4.5,0,0,0-1.07,3.24v.05a4.14,4.14,0,0,0,.46,1.62,4.06,4.06,0,0,0,1,1.32,4.18,4.18,0,0,0,1.47.82,4.3,4.3,0,0,0,1.67.18,173.28,173.28,0,0,1,75.22,11.11A169.59,169.59,0,0,1,429,194.82a4.37,4.37,0,0,0,2,1.22,4.31,4.31,0,0,0,2.31,0,4.4,4.4,0,0,0,1.85-1l0,0a4.51,4.51,0,0,0,1.07-1.41,4.64,4.64,0,0,0,.43-1.72,4.25,4.25,0,0,0-1.14-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M499.59,354.41q-.88,4.29-1.95,8.56a.43.43,0,0,0,0,.16.25.25,0,0,0,.06.14.29.29,0,0,0,.11.11.27.27,0,0,0,.15.05.37.37,0,0,0,.27-.05.44.44,0,0,0,.15-.23q1.08-4.33,2-8.71h-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M503.15,318.79a4.42,4.42,0,0,0-1.43-1,4.34,4.34,0,0,0-1.7-.34h0a4.5,4.5,0,0,0-4.45,4.3,193.53,193.53,0,0,1-22.36,83.48,195.92,195.92,0,0,1-56.62,65.86l-.27.2a4.43,4.43,0,0,0-1,6.06l0,0a4.45,4.45,0,0,0,1.24,1.17,4.36,4.36,0,0,0,1.6.59,4.26,4.26,0,0,0,1.81-.09,4.48,4.48,0,0,0,1.52-.74l.3-.21a203.89,203.89,0,0,0,69.81-92.89.4.4,0,0,0,0-.15.28.28,0,0,0,0-.15.38.38,0,0,0-.09-.12.5.5,0,0,0-.14-.08.38.38,0,0,0-.28,0,.39.39,0,0,0-.19.21,203.39,203.39,0,0,1-69.55,92.53l-.29.22a3.81,3.81,0,0,1-1.32.62,3.92,3.92,0,0,1-1.45.06,3.47,3.47,0,0,1-1.31-.49,3.42,3.42,0,0,1-1-1l0,0a3.69,3.69,0,0,1-.58-2.68,3.63,3.63,0,0,1,1.44-2.32l.27-.2a196.53,196.53,0,0,0,56.84-66.12,194.09,194.09,0,0,0,22.44-83.81,3.74,3.74,0,0,1,2.78-3.44,3.5,3.5,0,0,1,.91-.12h0a3.5,3.5,0,0,1,1.39.29,3.32,3.32,0,0,1,1.18.81,3.5,3.5,0,0,1,1,2.57,201.36,201.36,0,0,1-3.15,28.23.29.29,0,0,0,0,.16.35.35,0,0,0,.07.15.41.41,0,0,0,.13.1.32.32,0,0,0,.16,0,.38.38,0,0,0,.25-.09.36.36,0,0,0,.13-.23,202.79,202.79,0,0,0,3.16-28.33,4.33,4.33,0,0,0-1.17-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M493,380.67a.36.36,0,0,0,.19-.08.34.34,0,0,0,.11-.17q2.17-6.33,3.94-12.76a.33.33,0,0,0,0-.17.47.47,0,0,0-.06-.15.32.32,0,0,0-.12-.11.47.47,0,0,0-.15-.06.36.36,0,0,0-.26.07.37.37,0,0,0-.16.21q-1.74,6.42-3.92,12.72a.46.46,0,0,0,0,.2.76.76,0,0,0,.09.18.31.31,0,0,0,.16.11A.31.31,0,0,0,493,380.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M496.2,258.06a.46.46,0,0,0,.14-.07.35.35,0,0,0,.1-.11.44.44,0,0,0,.05-.15.38.38,0,0,0,0-.15,198.12,198.12,0,0,0-12.68-33.93.44.44,0,0,0-.19-.19.46.46,0,0,0-.26,0,.44.44,0,0,0-.15.08.41.41,0,0,0-.1.13.51.51,0,0,0,0,.17.29.29,0,0,0,0,.16,197.85,197.85,0,0,1,12.63,33.81.38.38,0,0,0,.18.23A.4.4,0,0,0,496.2,258.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M502,292.31a3.59,3.59,0,0,1-.15,1.42,3.79,3.79,0,0,1-.69,1.24,3.44,3.44,0,0,1-1.13.91,3.55,3.55,0,0,1-1.39.41h0a3.4,3.4,0,0,1-1.38-.13,3.52,3.52,0,0,1-2.09-1.74,3.63,3.63,0,0,1-.38-1.33,190.78,190.78,0,0,0-73.94-134.41,3.58,3.58,0,0,1-1.36-2.36,3.63,3.63,0,0,1,.09-1.39,3.45,3.45,0,0,1,.62-1.24l0,0a3.74,3.74,0,0,1,2-1.38l.43-.08a3.68,3.68,0,0,1,1.4.07,3.62,3.62,0,0,1,1.26.62A197.77,197.77,0,0,1,481,219.74a.38.38,0,0,0,.44.19.37.37,0,0,0,.15-.08.32.32,0,0,0,.1-.13.34.34,0,0,0,0-.17.33.33,0,0,0,0-.17,198.47,198.47,0,0,0-56-67.13,4.11,4.11,0,0,0-1.53-.74,4.23,4.23,0,0,0-1.7-.1,4.45,4.45,0,0,0-1.66.58,4.35,4.35,0,0,0-1.31,1.18l0,0a4.35,4.35,0,0,0-.84,3.2,4.41,4.41,0,0,0,1.65,2.86,190,190,0,0,1,73.64,133.86,4.37,4.37,0,0,0,1.54,2.92,4.3,4.3,0,0,0,3.14,1h0a3.68,3.68,0,0,0,.75-.13,4.39,4.39,0,0,0,2.3-1.47,4.18,4.18,0,0,0,.83-1.5,4.35,4.35,0,0,0,.19-1.72q-.78-8.71-2.32-17.3a.35.35,0,0,0-.06-.14.43.43,0,0,0-.11-.12l-.15,0a.29.29,0,0,0-.16,0,.36.36,0,0,0-.22.16.39.39,0,0,0-.06.28Q501.17,283.62,502,292.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M496.9,262.26c.68,2.74,1.31,5.5,1.87,8.27l.06.14a.29.29,0,0,0,.12.1.35.35,0,0,0,.14.06.38.38,0,0,0,.15,0,.37.37,0,0,0,.24-.17.39.39,0,0,0,0-.28c-.57-2.78-1.19-5.55-1.88-8.29a.35.35,0,0,0-.06-.14.35.35,0,0,0-.11-.1.3.3,0,0,0-.15,0,.26.26,0,0,0-.15,0,.36.36,0,0,0-.23.17A.42.42,0,0,0,496.9,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M347.76,127.05a190.09,190.09,0,0,1,50.93,20.67,4.05,4.05,0,0,0,5.48-1.34l0,0a3.9,3.9,0,0,0-1.29-5.52,198,198,0,0,0-53.08-21.55,4.09,4.09,0,0,0-4.9,3v0a3.91,3.91,0,0,0,2.84,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M120.07,243.11a262.72,262.72,0,0,1,34.37-60.56,5.77,5.77,0,0,0,1.15-3.73,5.24,5.24,0,0,0-1.47-3.47l0,0a4.17,4.17,0,0,0-1.53-1,4,4,0,0,0-1.78-.25,4.18,4.18,0,0,0-1.76.56,4.8,4.8,0,0,0-1.44,1.26A273,273,0,0,0,111.75,239a5.74,5.74,0,0,0-.11,4,4.76,4.76,0,0,0,2.43,2.81h.06a4,4,0,0,0,3.42,0A5,5,0,0,0,120.07,243.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M208.63,140.6a4,4,0,0,0,5.32,1.66,193.93,193.93,0,0,1,103.63-20.13,4.09,4.09,0,0,0,4.39-3.56v0a3.8,3.8,0,0,0-.12-1.57,3.84,3.84,0,0,0-.72-1.39,4,4,0,0,0-1.21-1,4,4,0,0,0-1.51-.43,202,202,0,0,0-108,21,4.21,4.21,0,0,0-1.25,1,4.07,4.07,0,0,0-1,2.95,4,4,0,0,0,.42,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M117.52,406.32a4,4,0,0,0,2.17-5.13,193.91,193.91,0,0,1-10.18-105.08,4.09,4.09,0,0,0-3.13-4.71h0a3.78,3.78,0,0,0-1.57,0,3.86,3.86,0,0,0-1.46.58,3.91,3.91,0,0,0-1.1,1.12,3.81,3.81,0,0,0-.58,1.45A202.08,202.08,0,0,0,112.23,404a4,4,0,0,0,.85,1.33,3.78,3.78,0,0,0,1.29.91,3.94,3.94,0,0,0,1.55.35,4.17,4.17,0,0,0,1.56-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M447.39,376.27a4.27,4.27,0,0,0-2-1.67,4.44,4.44,0,0,0-5.73,2.28,156.34,156.34,0,0,1-147.2,90.06,4.45,4.45,0,0,0-3.15,1.1,4.54,4.54,0,0,0-1.51,3v.05a4.3,4.3,0,0,0,.2,1.71,4.21,4.21,0,0,0,.85,1.5,4.2,4.2,0,0,0,3.05,1.46,162.18,162.18,0,0,0,47.79-5.21,165.51,165.51,0,0,0,86.9-56.33.39.39,0,0,0,.09-.26.47.47,0,0,0-.11-.25.34.34,0,0,0-.14-.09.37.37,0,0,0-.15,0l-.15,0-.13.1a165.59,165.59,0,0,1-29.94,28.85A163.74,163.74,0,0,1,291.91,475a3.64,3.64,0,0,1-1.38-.34,3.5,3.5,0,0,1-1.12-.86,3.34,3.34,0,0,1-.7-1.23,3.53,3.53,0,0,1-.16-1.41v0a3.78,3.78,0,0,1,.86-2.07,3.68,3.68,0,0,1,1.89-1.19,4.11,4.11,0,0,1,1.11-.12,157,157,0,0,0,147.94-90.48,3.66,3.66,0,0,1,4.74-1.89l0,0a3.46,3.46,0,0,1,1.17.79,3.38,3.38,0,0,1,.77,1.2,3.5,3.5,0,0,1,.23,1.4,3.64,3.64,0,0,1-.34,1.38c-.23.49-.46,1-.7,1.47a.32.32,0,0,0,0,.14.34.34,0,0,0,0,.14.36.36,0,0,0,.08.12.27.27,0,0,0,.12.09l.14,0a.34.34,0,0,0,.14,0,.33.33,0,0,0,.13-.07.31.31,0,0,0,.09-.11c.23-.49.47-1,.7-1.48a4.42,4.42,0,0,0,.41-2.12A4.23,4.23,0,0,0,447.39,376.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M329.33,426.28c30.9-24,98-159.45-34.44-159.45s-65.33,135.45-34.43,159.45c11.05,8.59,24.19,12.33,34.43,12.33S318.27,434.87,329.33,426.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M294.9,322.49c27.8,0,50.33-10.47,50.33-23.4s-22.53-23.4-50.33-23.4-50.34,10.48-50.34,23.4S267.1,322.49,294.9,322.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M365.61,208.56c26.41,37.26,6.22,96.75-70.72,96.75s-97.13-59.49-70.72-96.75c15.12-21.33,44.55-32.92,70.72-32.92S350.49,187.23,365.61,208.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M365.61,208.56c26.41,37.26,6.22,96.75-70.72,96.75s-97.13-59.49-70.72-96.75c15.12-21.33,44.55-32.92,70.72-32.92S350.49,187.23,365.61,208.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M294.89,296.05c36.7,0,66.44-21.19,66.44-47.33s-29.74-47.33-66.44-47.33-66.44,21.19-66.44,47.33S258.2,296.05,294.89,296.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M294.9,292.39c34.06,0,61.67-19.66,61.67-43.93S329,204.52,294.9,204.52s-61.68,19.68-61.68,43.94S260.83,292.39,294.9,292.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M348,245.34c0,5.95-8.1,9.61-18.5,11.79-11,2.29-24.55,2.94-34,2.86-13.53-.1-39.6-2-49-8.92-2.2-1.62-3.49-3.52-3.49-5.73a19.26,19.26,0,0,1,2.27-9,23.53,23.53,0,0,1,6.43-7.54,34.18,34.18,0,0,1,21-6.83c7.84,0,13.45,5.68,22.81,5.56,8.66-.11,18.29-5.54,22.79-5.56a36,36,0,0,1,13,2.35A29.79,29.79,0,0,1,341.75,231,20.27,20.27,0,0,1,348,245.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M218.86,181.37h-2.28v43.45h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M372.86,181.37h-2.28v43.45h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M218.78,184.4a6.75,6.75,0,1,0-7.71-5.59A6.76,6.76,0,0,0,218.78,184.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M372.78,184.4a6.75,6.75,0,1,0-7.71-5.59A6.76,6.76,0,0,0,372.78,184.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M217.7,271.42c6.15-.5,10.11-13.44,8.86-28.91s-7.26-27.61-13.41-27.11S203,228.84,204.3,244.31,211.56,271.91,217.7,271.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M218.88,272.47c6-1.29,8.27-14.63,5-29.81s-10.79-26.43-16.82-25.14-8.28,14.63-5,29.81S212.85,273.76,218.88,272.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M218.88,272.47c6-1.29,8.27-14.63,5-29.81s-10.79-26.43-16.82-25.14-8.28,14.63-5,29.81S212.85,273.76,218.88,272.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M385.5,244.32c1.26-15.47-2.71-28.42-8.86-28.91s-12.14,11.64-13.4,27.11,2.71,28.41,8.86,28.9S384.24,259.78,385.5,244.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M387.71,247.3c3.26-15.18,1-28.53-5-29.81s-13.57,10-16.83,25.14-1,28.52,5,29.81S384.45,262.47,387.71,247.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M387.71,247.3c3.26-15.18,1-28.53-5-29.81s-13.57,10-16.83,25.14-1,28.52,5,29.81S384.45,262.47,387.71,247.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M300.08,190.64l5.93-8.2a6.38,6.38,0,0,0-5.19-10.11H289a6.36,6.36,0,0,0-5.18,10.11l5.93,8.2a6.38,6.38,0,0,0,5.18,2.65,6.44,6.44,0,0,0,2.92-.7A6.37,6.37,0,0,0,300.08,190.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M267,252.73c5.88,0,10.65-5.76,10.65-12.87S272.88,227,267,227s-10.65,5.76-10.65,12.87S261.12,252.73,267,252.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M275.38,239.86c0,4.92-3.6,8.82-7.93,8.82s-7.93-3.9-7.93-8.82,3.59-8.82,7.93-8.82S275.38,234.94,275.38,239.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M268,246c2.21,0,4-2.69,4-6s-1.79-6-4-6-4,2.69-4,6S265.79,246,268,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M262.12,249.18A2.22,2.22,0,1,0,259.9,247,2.22,2.22,0,0,0,262.12,249.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M319.8,252.73c6.12,0,11.09-5.76,11.09-12.87S325.92,227,319.8,227s-11.1,5.76-11.1,12.87S313.67,252.73,319.8,252.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M327.73,239.86c0,4.92-3.6,8.82-7.93,8.82s-7.93-3.9-7.93-8.82,3.59-8.82,7.93-8.82S327.73,234.94,327.73,239.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M320,246c2.21,0,4-2.69,4-6s-1.79-6-4-6-4,2.69-4,6S317.79,246,320,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M314.47,249.18a2.22,2.22,0,1,0-2.22-2.22A2.22,2.22,0,0,0,314.47,249.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M295.39,282c-8.11,0-15.24-5.29-16.85-12.43,3.77,3,9.57,4.56,16.85,4.56s13.09-1.57,16.86-4.56C310.61,276.72,303.5,282,295.39,282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M229.52,334.33c4.58,0,8.29-8.73,8.29-19.49s-3.71-19.49-8.29-19.49-8.29,8.73-8.29,19.49S225,334.33,229.52,334.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M359.51,334.33c4.58,0,8.29-8.73,8.29-19.49s-3.71-19.49-8.29-19.49-8.29,8.73-8.29,19.49S354.93,334.33,359.51,334.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M273.55,347.46h0l5.23,52h0c.33,3.35,3,6.14,6.16,6.14h19.93c3.16,0,5.81-2.79,6.15-6.15l5.23-51.94h0a13.55,13.55,0,0,0-1.38-7.84A6.23,6.23,0,0,0,309.5,336H280.3a6.23,6.23,0,0,0-5.37,3.59A13.63,13.63,0,0,0,273.55,347.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M287.14,360v5.69a1.07,1.07,0,0,0-.69.4,1.09,1.09,0,0,0,.12,1.48,1.1,1.1,0,0,0,1.49,0,1.09,1.09,0,0,0,.12-1.48,1.07,1.07,0,0,0-.69-.4V360a1.08,1.08,0,0,0,.68-.41,1,1,0,0,0,.23-.76,1.08,1.08,0,0,0-1.08-1,1.1,1.1,0,0,0-.75.29,1.09,1.09,0,0,0-.34.71,1.07,1.07,0,0,0,.22.76A1.15,1.15,0,0,0,287.14,360Zm.92,6.76a.7.7,0,0,1-.13.42.73.73,0,0,1-.33.27.71.71,0,0,1-.43,0,.67.67,0,0,1-.38-.2.72.72,0,0,1-.21-.38.8.8,0,0,1,.05-.43.72.72,0,0,1,.27-.33.77.77,0,0,1,.42-.13.71.71,0,0,1,.28.06.6.6,0,0,1,.25.16.81.81,0,0,1,.17.24.92.92,0,0,1,.05.28Zm-.74-8.58a.69.69,0,0,1,.41.13.67.67,0,0,1,.27.33.78.78,0,0,1,.05.43.76.76,0,0,1-.21.38.74.74,0,0,1-.38.2.8.8,0,0,1-.43,0,.73.73,0,0,1-.33-.27.72.72,0,0,1-.13-.42.75.75,0,0,1,.75-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M298.84,377.7a1.06,1.06,0,0,0-.12-.5,1.07,1.07,0,0,0-.34-.39l2.13-3.69h.26v-.44l.19-.32-.19-.11V359.89a1.08,1.08,0,0,0,.6-.51A1.09,1.09,0,0,0,301,358a1.15,1.15,0,0,0-.77-.16,1,1,0,0,0-.67.4,1.07,1.07,0,0,0-.23.75,1,1,0,0,0,.34.7,1.05,1.05,0,0,0,.73.29v12.64l-2.35,4.07a1.19,1.19,0,0,0-.32,0,1.09,1.09,0,0,0-.61.18,1.22,1.22,0,0,0-.41.49,1.18,1.18,0,0,0-.06.64,1.09,1.09,0,0,0,1.5.79,1.07,1.07,0,0,0,.49-.4,1.09,1.09,0,0,0,.18-.61Zm.86-18.86a.75.75,0,0,1,.12-.41.7.7,0,0,1,.34-.27.78.78,0,0,1,.43-.05.76.76,0,0,1,.38.21.74.74,0,0,1,.2.38.71.71,0,0,1,0,.43.72.72,0,0,1-.69.45.59.59,0,0,1-.29-.05.75.75,0,0,1-.24-.15.63.63,0,0,1-.16-.24,1,1,0,0,1-.07-.28Zm-1.95,19.59a.73.73,0,0,1-.41-.12.74.74,0,0,1-.28-.33.8.8,0,0,1,0-.43.78.78,0,0,1,.59-.59.76.76,0,0,1,.76.32.76.76,0,0,1,.13.41.82.82,0,0,1-.22.54.67.67,0,0,1-.25.16.72.72,0,0,1-.29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M304.08,376.61l-.24,0-1.27-2.14h0V355.19a1.12,1.12,0,0,0,.7-.41,1.09,1.09,0,0,0,.23-.76,1.08,1.08,0,0,0-.35-.72,1.11,1.11,0,0,0-.75-.3,1.09,1.09,0,0,0-.75.3,1.08,1.08,0,0,0-.35.72,1.09,1.09,0,0,0,.23.76,1.13,1.13,0,0,0,.69.41V374l-.28.16.12.21-1.31,2.24a1.1,1.1,0,0,0-1,1.1,1.05,1.05,0,0,0,.29.73,1.1,1.1,0,0,0,.71.35,1.11,1.11,0,0,0,1.18-.91,1.16,1.16,0,0,0-.16-.77,1.12,1.12,0,0,0-.64-.47l1.12-1.92,1.2,2.05a1,1,0,0,0-.41.49,1,1,0,0,0-.06.64,1,1,0,0,0,.31.56,1.06,1.06,0,0,0,.58.28v3.48l-4.07,2.49a1,1,0,0,0-.56-.16,1.11,1.11,0,0,0-1,1.59,1.11,1.11,0,0,0,.53.52,1.14,1.14,0,0,0,.73.07,1.12,1.12,0,0,0,.62-.4,1.15,1.15,0,0,0,.23-.7,1.07,1.07,0,0,0-.26-.68l4.06-2.49-.1-.14h.18v-3.58a1.09,1.09,0,0,0,.56-1.87,1.06,1.06,0,0,0-.74-.29Zm-2.42,1.09a.74.74,0,0,1-.13.41.72.72,0,0,1-.33.27.8.8,0,0,1-.43.05.78.78,0,0,1-.59-.59.76.76,0,0,1,.32-.76.76.76,0,0,1,.41-.13.75.75,0,0,1,.75.75Zm0-23.59a.78.78,0,0,1,.12-.41.75.75,0,0,1,.34-.27.7.7,0,0,1,.43,0,.72.72,0,0,1,.58.58.71.71,0,0,1,0,.43.67.67,0,0,1-.27.33.8.8,0,0,1-.42.13.75.75,0,0,1-.74-.75ZM300,385.66a.75.75,0,0,1-.46.69.74.74,0,0,1-.44,0,.72.72,0,0,1-.58-.58.8.8,0,0,1,0-.43.75.75,0,0,1,.28-.33.67.67,0,0,1,.41-.13.69.69,0,0,1,.2,0l-.28.17.18.3.44-.27a.77.77,0,0,1,.2.5Zm4-7.2a.78.78,0,0,1-.69-.46.8.8,0,0,1,0-.43A.78.78,0,0,1,304,377a.8.8,0,0,1,.43,0,.72.72,0,0,1,.33.27.71.71,0,0,1-.1.93.75.75,0,0,1-.53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M297.08,370.35a1.1,1.1,0,0,0,.17.59,1.08,1.08,0,0,0,1.07.5,1.06,1.06,0,0,0,.56-.25,1.08,1.08,0,0,0,0-1.65,1.08,1.08,0,0,0-.55-.26V354.69a1,1,0,0,0,.68-.4,1.09,1.09,0,1,0-1.95-.76,1.11,1.11,0,0,0,.23.76,1,1,0,0,0,.69.4v14.59a1.12,1.12,0,0,0-.66.37A1.06,1.06,0,0,0,297.08,370.35Zm1.84,0a.67.67,0,0,1-.13.41.69.69,0,0,1-.33.28.8.8,0,0,1-.43,0,.74.74,0,0,1-.38-.2.76.76,0,0,1-.21-.38.78.78,0,0,1,.05-.43.74.74,0,0,1,1.21-.24A.71.71,0,0,1,298.92,370.35Zm-1.49-16.75a.71.71,0,0,1,.46-.68.7.7,0,0,1,.43,0,.64.64,0,0,1,.38.2.67.67,0,0,1,.2.38.71.71,0,0,1,0,.43.75.75,0,0,1-.69.46.74.74,0,0,1-.52-.22.7.7,0,0,1-.22-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M284.5,385.51a1.25,1.25,0,0,0-.42.08v-3.07l2.79-3.71a1.14,1.14,0,0,0,.69-.34,1.12,1.12,0,0,0,.29-.71,1.09,1.09,0,0,0-.92-1.11v-3.16h-.17l.17,0-1.87-7.15V352.63h.07a1.1,1.1,0,0,0,1.1-1,1.09,1.09,0,0,0-.21-.76,1.09,1.09,0,0,0-1.45-.29,1,1,0,0,0-.49.62,1.08,1.08,0,0,0,.06.79,1.09,1.09,0,0,0,.57.55v3.21l-2.39,4.05h-.09V360l-.06.1.06,0v5.56a1.09,1.09,0,0,0-.92,1.17,1.1,1.1,0,0,0,2.19,0,1.09,1.09,0,0,0-.92-1.17v-5.6l2.13-3.61v14.88h.3l-1.5,2.93a1.05,1.05,0,0,0-.88,1.15,1,1,0,0,0,.34.7,1.09,1.09,0,0,0,1.46,0,1,1,0,0,0,.34-.7,1.05,1.05,0,0,0-.88-1.15l1.52-3-.32-.16,0,.07v-3.55l1.53,5.82v3.16a1.12,1.12,0,0,0-.64.34,1.06,1.06,0,0,0-.28.67,1,1,0,0,0,.2.7,1,1,0,0,0,.59.41l-2.71,3.61.06,0h-.07v3.3h.13a1.09,1.09,0,0,0-.33,1.38,1.11,1.11,0,0,0,.56.51,1.1,1.1,0,0,0,.76,0,1.08,1.08,0,0,0,.73-1.21,1.11,1.11,0,0,0-1.09-.91Zm-.12-34a.72.72,0,0,1,.13-.42.73.73,0,0,1,.33-.27.71.71,0,0,1,.43,0,.74.74,0,0,1,.38.2.76.76,0,0,1,.21.38.78.78,0,0,1-.05.43.67.67,0,0,1-.27.33.76.76,0,0,1-.41.13h-.07v-.07h-.23a.71.71,0,0,1-.32-.27A.73.73,0,0,1,284.38,351.55Zm-1.23,15.19a.74.74,0,0,1-.13.41.76.76,0,0,1-.76.32.78.78,0,0,1-.59-.59.8.8,0,0,1,0-.43.81.81,0,0,1,.28-.33.75.75,0,0,1,.41-.12.93.93,0,0,1,.29.05.85.85,0,0,1,.25.17.72.72,0,0,1,.16.25.93.93,0,0,1,0,.29Zm1.24,8.6a.73.73,0,0,1-.12.41.72.72,0,0,1-.34.28.78.78,0,0,1-.43,0,.82.82,0,0,1-.38-.2.81.81,0,0,1-.2-.39.67.67,0,0,1,0-.42.76.76,0,0,1,.27-.34.79.79,0,0,1,.42-.12.71.71,0,0,1,.52.22A.67.67,0,0,1,284.39,375.34Zm1.63,2.39a.79.79,0,0,1,.12-.42.76.76,0,0,1,.34-.27.7.7,0,0,1,.43,0,.82.82,0,0,1,.38.2.78.78,0,0,1,.2.38.72.72,0,0,1-.32.76.74.74,0,0,1-.41.13h-.06a.76.76,0,0,1-.49-.24A.73.73,0,0,1,286,377.73Zm-1.52,9.61a.75.75,0,0,1-.41-.12.79.79,0,0,1-.32-.77.76.76,0,0,1,.21-.38.74.74,0,0,1,.38-.2.8.8,0,0,1,.43,0,.81.81,0,0,1,.33.28.74.74,0,0,1,.13.41.73.73,0,0,1-.22.52A.75.75,0,0,1,284.5,387.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M287.63,385.08a1,1,0,0,0-.61.19,1.15,1.15,0,0,0-.41.49,1.13,1.13,0,0,0-.06.63,1.1,1.1,0,0,0,.3.56,1.14,1.14,0,0,0,.56.3,1.12,1.12,0,0,0,1.13-.47,1,1,0,0,0,.18-.61,1.07,1.07,0,0,0-.32-.77A1.1,1.1,0,0,0,287.63,385.08Zm0,1.84a.74.74,0,0,1-.41-.13.81.81,0,0,1-.28-.33.8.8,0,0,1,0-.43.74.74,0,0,1,.2-.38.76.76,0,0,1,.38-.21.83.83,0,0,1,.44.05.72.72,0,0,1,.33.27.76.76,0,0,1,.13.41.75.75,0,0,1-.22.53.78.78,0,0,1-.53.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M296.42,391.88V374.39A1.11,1.11,0,0,0,297,374a1.08,1.08,0,0,0-.8-1.7V361.05c0-1.27-.54-2.26-1.23-2.26s-1.14.85-1.21,2v10.67c0,1-.45,1.92-1,1.92s-1-.88-1-1.92V354.32c0-1.26-.58-2.26-1.33-2.26s-1.32,1-1.32,2.26v16.32a1.07,1.07,0,0,0-.66.37,1,1,0,0,0-.26.7,1.09,1.09,0,0,0,.26.71,1.07,1.07,0,0,0,.66.37v8.36h.08l-.12.06,2.31,3.94a1.09,1.09,0,0,0-.68,1.31,1.09,1.09,0,0,0,.47.64,1.07,1.07,0,0,0,.78.15,1.09,1.09,0,0,0,.89-1.17,1.1,1.1,0,0,0-.35-.71,1.12,1.12,0,0,0-.74-.28h-.15l.12-.07-2.28-3.89v-8.36a1.11,1.11,0,0,0,.93-1.07,1.1,1.1,0,0,0-.27-.71,1,1,0,0,0-.66-.37V354.31c0-1,.45-1.92,1-1.92s1,.88,1,1.92v17.14c0,1.26.58,2.26,1.33,2.26.56,0,1-.57,1.22-1.39h.11V361c0-1.12.46-1.89.87-1.89s.88.78.88,1.89v11.23a1.1,1.1,0,0,0-.55.32,1.06,1.06,0,0,0-.28.57,1.13,1.13,0,0,0,.09.63,1,1,0,0,0,.43.47l-1.35,2.31a.78.78,0,0,0-.26,0,1.14,1.14,0,0,0-.79.28,1.1,1.1,0,0,0-.08,1.53,1,1,0,0,0,.75.36v8.64a1.11,1.11,0,0,0-1.08,1,1.09,1.09,0,0,0,.25.77,1.15,1.15,0,0,0,.71.39,1.09,1.09,0,0,0,.78-.19,1.11,1.11,0,0,0,.45-.67,1.11,1.11,0,0,0-.76-1.29v-8.7a1.1,1.1,0,0,0,.84-.88,1.05,1.05,0,0,0-.07-.63,1.19,1.19,0,0,0-.41-.48l1.34-2.3.17,0v17.45h.1a1.14,1.14,0,0,0-.72.38,1.17,1.17,0,0,0-.26.78,1.11,1.11,0,0,0,1.11,1,1.14,1.14,0,0,0,.76-.3,1.11,1.11,0,0,0,.34-.74,1.07,1.07,0,0,0-.26-.78,1.11,1.11,0,0,0-.72-.38Zm-3.87-5.71a.67.67,0,0,1-.13.41.75.75,0,0,1-.33.28.8.8,0,0,1-.43,0,.74.74,0,0,1-.38-.2.72.72,0,0,1-.16-.81.7.7,0,0,1,.27-.34.75.75,0,0,1,.41-.12.93.93,0,0,1,.29.05,1,1,0,0,1,.24.16.82.82,0,0,1,.16.25A.67.67,0,0,1,292.55,386.17Zm-2.47-14.47a.79.79,0,0,1-.12.42.76.76,0,0,1-.34.27.7.7,0,0,1-.43,0,.82.82,0,0,1-.38-.2.76.76,0,0,1-.16-.81.73.73,0,0,1,.27-.33.72.72,0,0,1,.42-.13.75.75,0,0,1,.74.74Zm4.55,16.73a.79.79,0,0,1-.12.42.82.82,0,0,1-.34.27.76.76,0,0,1-.81-.16.74.74,0,0,1-.2-.38.7.7,0,0,1,0-.43.67.67,0,0,1,.27-.33.72.72,0,0,1,.42-.13.74.74,0,0,1,.52.22A.73.73,0,0,1,294.63,388.43ZM294,378.37a.71.71,0,0,1-.68-.46.78.78,0,0,1,0-.43.76.76,0,0,1,.21-.38.74.74,0,0,1,.38-.2.8.8,0,0,1,.43,0,.69.69,0,0,1,.33.28.67.67,0,0,1,.13.41.73.73,0,0,1-.22.52A.75.75,0,0,1,294,378.37Zm2.18-5.77a.75.75,0,0,1,.41.12.7.7,0,0,1,.27.34.75.75,0,0,1,.05.42.68.68,0,0,1-.21.38.72.72,0,0,1-.38.21.8.8,0,0,1-.43,0,.69.69,0,0,1-.33-.28.7.7,0,0,1-.07-.69.56.56,0,0,1,.16-.24.81.81,0,0,1,.24-.17A.93.93,0,0,1,296.14,372.6Zm.16,21.1a.69.69,0,0,1-.41-.13.67.67,0,0,1-.27-.33.7.7,0,0,1-.05-.43.76.76,0,0,1,.21-.38.74.74,0,0,1,.38-.2.71.71,0,0,1,.43,0,.73.73,0,0,1,.33.27.8.8,0,0,1,.13.42.74.74,0,0,1-.22.52.73.73,0,0,1-.52.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M305.27,369.15a1,1,0,0,0,.41-.45,1,1,0,0,0,.1-.6,1.05,1.05,0,0,0-.73-.9V349.67a1.1,1.1,0,0,0,.64-.48,1.12,1.12,0,0,0,.15-.78,1.15,1.15,0,0,0-.43-.68,1.12,1.12,0,0,0-.77-.21,1.08,1.08,0,0,0-.71.37,1.1,1.1,0,0,0-.27.75,1,1,0,0,0,.31.74,1.15,1.15,0,0,0,.73.33v17.43a1,1,0,0,0-.74.34,1.09,1.09,0,0,0,.74,1.84l.24,0,3.24,5,.3-.19ZM304,348.61a.75.75,0,0,1,.12-.41.72.72,0,0,1,.33-.27.74.74,0,0,1,.44,0,.67.67,0,0,1,.38.2.78.78,0,0,1,.2.38.8.8,0,0,1,0,.43.78.78,0,0,1-.69.46.75.75,0,0,1-.74-.74ZM304,368.2a.75.75,0,0,1,.46-.68.71.71,0,0,1,.43,0,.74.74,0,0,1,.38.2.72.72,0,0,1,.21.38.8.8,0,0,1,0,.43.75.75,0,0,1-.28.33.73.73,0,0,1-.93-.08.78.78,0,0,1-.23-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M409.6,377l6.1-2.74a3.17,3.17,0,0,0,1.7-4.5l-37.1-65c-3.92-6.86-12.46-6.93-18.8-2.13-9.54,7.22-5.27,17.2.64,25,12.59,16.62,28.47,31.81,41.82,48.11A5,5,0,0,0,409.6,377Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M409.6,377l6.1-2.74a3.17,3.17,0,0,0,1.7-4.5l-37.1-65c-3.92-6.86-12.46-6.93-18.8-2.13-9.54,7.22-5.27,17.2.64,25,12.59,16.62,28.47,31.81,41.82,48.11A5,5,0,0,0,409.6,377Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M381.17,430.19l5.33,1.4a3.82,3.82,0,0,0,4.27-1.8l28.29-56.15c3-5.93-1.58-10.16-8.55-10.47-10.53-.47-15.65,7.46-18.26,14.92C386.7,394,384,410.64,379,426.72A2.77,2.77,0,0,0,381.17,430.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M378.84,429.7l6.6,1.83c2,.57,4.27,0,5-1.37,0,0,29.31-52.07,29.4-52.24,3.11-5.52-2.82-10-11.35-11-12.84-1.39-18.36,5.89-20.87,12.93-5.34,15-7.17,31-11.72,46.23C375.49,427.56,376.8,429.14,378.84,429.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M378.84,429.7l6.6,1.83c2,.57,4.27,0,5-1.37,0,0,29.31-52.07,29.4-52.24,3.11-5.52-2.82-10-11.35-11-12.84-1.39-18.36,5.89-20.87,12.93-5.34,15-7.17,31-11.72,46.23C375.49,427.56,376.8,429.14,378.84,429.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M377.82,418.48a34.89,34.89,0,0,1-1.65,5.07,17.19,17.19,0,0,1-4.53,5l-10.09,8.37a9.62,9.62,0,0,0-2.37,2.51c-1,1.79-.61,4.4,1.43,4.92s3.55-1.65,5.27-2.26a1.75,1.75,0,0,1,2.28.93,2.4,2.4,0,0,1-.09,1.52,6.91,6.91,0,0,1-2,2.71c-2.07,2-4.49,3.7-7.18,4.06a19.23,19.23,0,0,0-2.73.35,2.93,2.93,0,0,0-2.06,1.87c-1.54,5.15,7.12,3.18,8.76,2.64l-1.73,2.31a1,1,0,0,0-.22.4,1,1,0,0,0,0,.35.8.8,0,0,0,.14.31c.72,1.26,2.32,1.21,3.61.91a23.38,23.38,0,0,0,5.56-2.08,2.16,2.16,0,0,0,1,2.64,3.89,3.89,0,0,0,2.79,0c1.86-.52,3.52-1.58,5.33-2.2,1.29-.44,2.81-.2,4.31-1,4.11-2.17,6.78-5.63,9.23-9.92,3.73-6.54.41-12.64,1-19.52a31.13,31.13,0,0,0,.43-5c-.39-5.94-6.19-7.89-10.47-8.19a9,9,0,0,0-3.1.2,4.07,4.07,0,0,0-2.51,1.94A9,9,0,0,0,377.82,418.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M376.48,422.41c-.64,1.58-.91,3.36-1.82,4.86a17.68,17.68,0,0,1-5,4.78l-11.09,8a9.92,9.92,0,0,0-2.59,2.41c-1.12,1.71-.68,4.22,1.56,4.71s3.91-1.58,5.79-2.17a1.75,1.75,0,0,1,2.41,2.35,6.86,6.86,0,0,1-2.16,2.61,15.62,15.62,0,0,1-7.88,3.89,23.13,23.13,0,0,0-3,.33,3.12,3.12,0,0,0-2.26,1.8c-1.69,4.93,7.82,3,9.62,2.53l-1.9,2.21a1,1,0,0,0-.24.39.74.74,0,0,0,0,.33.85.85,0,0,0,.15.3c.79,1.2,2.55,1.16,4,.87a28.36,28.36,0,0,0,6.11-2,2,2,0,0,0,1.14,2.53,5,5,0,0,0,3.07,0c2-.51,3.86-1.52,5.85-2.11,1.42-.43,3.08-.19,4.73-1,4.51-2.08,7.45-5.4,10.14-9.51,4.1-6.27.44-12.12,1.13-18.72a26.61,26.61,0,0,0,.47-4.78c-.43-5.69-6.79-7.56-11.5-7.85a11,11,0,0,0-3.39.19,4.44,4.44,0,0,0-2.76,1.86A7.09,7.09,0,0,0,376.48,422.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M147.88,290.41l-3,6a3.18,3.18,0,0,0,1.56,4.56l70,26.67c7.4,2.82,14-2.53,15.88-10.26,2.77-11.62-6.89-16.62-16.43-18.9-20.31-4.85-42.25-6.53-62.94-10.67A5,5,0,0,0,147.88,290.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M135.93,231.29l-5,2.3a3.81,3.81,0,0,0-2.16,4.1L142.69,299c1.47,6.47,7.69,6.84,13.29,2.65,8.42-6.32,7.32-15.67,4.59-23.09-5.83-15.79-14.34-30.39-20.77-45.92A2.79,2.79,0,0,0,135.93,231.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M138.05,230.18,131.79,233c-1.93.86-3.28,2.73-3,4.25,0,0,10.53,58.78,10.56,59,1.11,6.23,8.57,6,15.75,1.26,10.8-7.06,10.42-16.18,7.88-23.2-5.43-15-14.21-28.49-20.38-43.15C142,229.71,140,229.33,138.05,230.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M138.05,230.18,131.79,233c-1.93.86-3.28,2.73-3,4.25,0,0,10.53,58.78,10.56,59,1.11,6.23,8.57,6,15.75,1.26,10.8-7.06,10.42-16.18,7.88-23.2-5.43-15-14.21-28.49-20.38-43.15C142,229.71,140,229.33,138.05,230.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M144.24,234.85c-.49-1.6-1.39-3.11-1.63-4.83a17.87,17.87,0,0,1,.76-6.73l3.36-13a10.15,10.15,0,0,0,.45-3.45c-.22-2-2.09-3.63-4.05-2.61s-1.93,3.65-3,5.26a1.92,1.92,0,0,1-2.41.88,2,2,0,0,1-.81-1.16,6.9,6.9,0,0,1,0-3.32A15.35,15.35,0,0,1,140.4,198a21.28,21.28,0,0,0,2-2.12,3.06,3.06,0,0,0,.58-2.77c-1.76-4.81-7.67,2.55-8.69,4.07l.05-2.87a1.12,1.12,0,0,0-.06-.45.88.88,0,0,0-.22-.25.71.71,0,0,0-.29-.14c-1.33-.42-2.61.71-3.49,1.81A27.52,27.52,0,0,0,127,200.6a1.89,1.89,0,0,0-2.4-1.2,4.74,4.74,0,0,0-2.27,1.92c-1.22,1.66-1.94,3.56-3,5.25-.79,1.21-2.17,2.07-2.93,3.67-2.08,4.39-2.23,8.74-1.7,13.54.79,7.32,7.09,9.49,10.62,14.92a27.24,27.24,0,0,0,2.59,3.93c3.8,4,9.68,1.51,13.35-1.21a11,11,0,0,0,2.42-2.25,4.52,4.52,0,0,0,.91-3.14A7.82,7.82,0,0,0,144.24,234.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M142.65,231.54c-.52-1.62-1.44-3.16-1.7-4.9a18,18,0,0,1,.79-6.84l3.49-13.23a9.71,9.71,0,0,0,.47-3.5c-.23-2-2.16-3.69-4.21-2.65s-2,3.71-3.09,5.34a2,2,0,0,1-2.5.89,2,2,0,0,1-.85-1.18,6.86,6.86,0,0,1,0-3.37,15.37,15.37,0,0,1,3.61-8,23.76,23.76,0,0,0,2.1-2.16,3.09,3.09,0,0,0,.6-2.82c-1.83-4.88-8,2.6-9,4.14l.06-2.92a1.19,1.19,0,0,0-.06-.46.92.92,0,0,0-.23-.25.68.68,0,0,0-.31-.14c-1.38-.43-2.71.72-3.62,1.84a27.93,27.93,0,0,0-3.44,5.4,2,2,0,0,0-2.49-1.22,4.94,4.94,0,0,0-2.36,2c-1.26,1.68-2,3.62-3.17,5.33-.82,1.23-2.26,2.11-3,3.73-2.16,4.47-2.31,8.89-1.77,13.76.83,7.45,7.38,9.65,11.05,15.17a26.05,26.05,0,0,0,2.69,4c3.95,4.11,10,1.54,13.87-1.22a11,11,0,0,0,2.51-2.3,4.42,4.42,0,0,0,.95-3.19A8.42,8.42,0,0,0,142.65,231.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M142.65,231.54c-.52-1.62-1.44-3.16-1.7-4.9a18,18,0,0,1,.79-6.84l3.49-13.23a9.71,9.71,0,0,0,.47-3.5c-.23-2-2.16-3.69-4.21-2.65s-2,3.71-3.09,5.34a2,2,0,0,1-2.5.89,2,2,0,0,1-.85-1.18,6.86,6.86,0,0,1,0-3.37,15.37,15.37,0,0,1,3.61-8,23.76,23.76,0,0,0,2.1-2.16,3.09,3.09,0,0,0,.6-2.82c-1.83-4.88-8,2.6-9,4.14l.06-2.92a1.19,1.19,0,0,0-.06-.46.92.92,0,0,0-.23-.25.68.68,0,0,0-.31-.14c-1.38-.43-2.71.72-3.62,1.84a27.93,27.93,0,0,0-3.44,5.4,2,2,0,0,0-2.49-1.22,4.94,4.94,0,0,0-2.36,2c-1.26,1.68-2,3.62-3.17,5.33-.82,1.23-2.26,2.11-3,3.73-2.16,4.47-2.31,8.89-1.77,13.76.83,7.45,7.38,9.65,11.05,15.17a26.05,26.05,0,0,0,2.69,4c3.95,4.11,10,1.54,13.87-1.22a11,11,0,0,0,2.51-2.3,4.42,4.42,0,0,0,.95-3.19A8.42,8.42,0,0,0,142.65,231.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 556.61,
    cy: 323.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M555,328c4.9,0,13.08,6.67,13.08,6.67V308s-8.18,6.67-13.08,6.67Zm-9.82,0,4.91,13.33h6.54L551.72,328m16.35-1.67A4.89,4.89,0,0,0,570,326a5,5,0,0,0,1.59-1.08,5.28,5.28,0,0,0,1.06-1.62,5.07,5.07,0,0,0-1.06-5.45,4.82,4.82,0,0,0-3.47-1.47m-27.8,5c0-5.18,2.93-6.66,6.54-6.66H555V328h-8.18C543.2,328,540.27,326.52,540.27,321.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-72",
    cx: 502.61,
    cy: 105.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M486.52,117.23l0,0a10.06,10.06,0,0,1-.85-3.33A10,10,0,0,0,486.52,117.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M497.22,102.85a4,4,0,1,0-4-4A4,4,0,0,0,497.22,102.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M509.2,88.88h-14c-6.06,0-9.68,3.62-9.68,9.69v14a11.35,11.35,0,0,0,.93,4.74c1.44,3.16,4.5,5,8.75,5h14c6.07,0,9.68-3.62,9.68-9.69v-14C518.88,92.5,515.27,88.88,509.2,88.88Zm7,17.5a3.73,3.73,0,0,0-4.7,0l-6.94,6a3.71,3.71,0,0,1-4.7,0l-.56-.46a3.69,3.69,0,0,0-4.4-.24l-6.24,4.19a9.08,9.08,0,0,1-.58-3.29v-14c0-4.7,2.48-7.19,7.18-7.19h14c4.7,0,7.18,2.49,7.18,7.19v8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 76.61,
    cy: 113.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M83,114.67v6.78a6,6,0,0,1-.21,1.68,5.27,5.27,0,0,1-5.45,4H72.78l-5,3.35a1.12,1.12,0,0,1-1.75-.94v-2.41a5.36,5.36,0,0,1-5.67-5.67v-6.78a5.32,5.32,0,0,1,5-5.64c.22,0,.44,0,.67,0H77.32A5.35,5.35,0,0,1,83,114.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M86.58,120a6.7,6.7,0,0,0,7.09-7.08v-8.5a7.08,7.08,0,0,0-7.09-7.09H72.42a7.08,7.08,0,0,0-7.09,7.09v1.25a.83.83,0,0,0,.84.83H77.32a8.16,8.16,0,0,1,8.16,8.17v4.5a.83.83,0,0,0,.84.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 117.61,
    cy: 539.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M117.63,535.28c-1.65,0-3,1.65-3,3.67a4.11,4.11,0,0,0,1,2.72.77.77,0,0,1,.19.34l1,4h1.67l1-4a.7.7,0,0,1,.18-.34,4.08,4.08,0,0,0,1-2.72C120.63,536.93,119.29,535.28,117.63,535.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M117.63,529a9.07,9.07,0,0,0-8.43,5.72,9,9,0,0,0,2.22,9.92l1.45,5a1.85,1.85,0,0,0-1,.64,1.79,1.79,0,0,0-.4,1.13v.22a1.81,1.81,0,0,0,.21.85,1.87,1.87,0,0,0,.6.65,1.9,1.9,0,0,0-.6.66,1.78,1.78,0,0,0-.21.85v.22a1.86,1.86,0,0,0,.22.86,1.81,1.81,0,0,0,.61.65,1.82,1.82,0,0,0-.83,1.52v.21a1.81,1.81,0,0,0,1.82,1.82H122a1.81,1.81,0,0,0,1.28-.53,1.78,1.78,0,0,0,.54-1.29V558a1.83,1.83,0,0,0-.22-.86,1.93,1.93,0,0,0-.61-.66,1.9,1.9,0,0,0,.61-.65,1.86,1.86,0,0,0,.22-.86v-.22a1.87,1.87,0,0,0-.81-1.51,1.76,1.76,0,0,0,.59-.65,1.82,1.82,0,0,0,.22-.85v-.22a1.79,1.79,0,0,0-.4-1.13,1.85,1.85,0,0,0-1-.64l1.45-5a9.09,9.09,0,0,0,2.64-4.62,9,9,0,0,0-3.76-9.45A9.08,9.08,0,0,0,117.63,529ZM121,542.59l-1.09,4.48a.82.82,0,0,1-.78.6h-2.93a.77.77,0,0,1-.78-.6l-1.1-4.48A5.65,5.65,0,0,1,113,539c0-2.91,2.06-5.27,4.6-5.27s4.61,2.36,4.61,5.27a5.56,5.56,0,0,1-1.27,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M112.7,527a.81.81,0,0,0,.29.29.84.84,0,0,0,.41.11.8.8,0,0,0,.4-.11.74.74,0,0,0,.23-.2.82.82,0,0,0,.14-.28.66.66,0,0,0,0-.31.76.76,0,0,0-.1-.3l-3.31-5.73a1,1,0,0,0-.21-.24.92.92,0,0,0-.28-.14,1.08,1.08,0,0,0-.31,0,.76.76,0,0,0-.3.1,1,1,0,0,0-.24.21.72.72,0,0,0-.13.28.82.82,0,0,0,0,.31.84.84,0,0,0,.11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M121.47,527.25a.8.8,0,0,0,1.09-.29l3.32-5.73a.84.84,0,0,0,.11-.3.86.86,0,0,0,0-.32,1,1,0,0,0-.14-.29.69.69,0,0,0-.24-.21.67.67,0,0,0-.3-.1.69.69,0,0,0-.32,0,.8.8,0,0,0-.29.15.82.82,0,0,0-.2.25l-3.32,5.73a1,1,0,0,0-.1.3,1.1,1.1,0,0,0,0,.31,1,1,0,0,0,.14.28A.91.91,0,0,0,121.47,527.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M103.37,526a.79.79,0,0,0-1.13,0,.79.79,0,0,0,0,1.13l4.68,4.68a.81.81,0,0,0,1.14-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M133,526a.79.79,0,0,0-1.13,0l-4.69,4.67a.87.87,0,0,0-.18.26.81.81,0,0,0-.06.31.85.85,0,0,0,.06.31.87.87,0,0,0,.18.26.78.78,0,0,0,.26.17.81.81,0,0,0,.31.06.77.77,0,0,0,.3-.06.78.78,0,0,0,.26-.17l4.69-4.68a.68.68,0,0,0,.18-.26.81.81,0,0,0,.06-.31.77.77,0,0,0-.06-.3A.68.68,0,0,0,133,526Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-85",
    cx: 469.61,
    cy: 539.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M483,527a12.63,12.63,0,0,0-21,12.67l-7.83,7.83a3.37,3.37,0,0,0-.82,2.49l.5,3.63a3.15,3.15,0,0,0,2.5,2.5l3.63.5a3.25,3.25,0,0,0,2.49-.83l1.36-1.37a.81.81,0,0,0,0-1.18L460.6,550a1.25,1.25,0,0,1,1.77-1.76l3.25,3.25a.84.84,0,0,0,1.16,0l3.54-3.52A12.61,12.61,0,0,0,483,527Zm-8.81,13a4.17,4.17,0,1,1,4.16-4.17A4.17,4.17,0,0,1,474.17,540Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 282.61,
    cy: 35.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M289.41,28.92a.69.69,0,0,0-.42-.38.73.73,0,0,0-.56,0,.75.75,0,0,0-.38.42.73.73,0,0,0,0,.56,7.25,7.25,0,0,1,.66,2.86,7.17,7.17,0,0,1-.55,2.88A8.21,8.21,0,0,1,284,39.65a.72.72,0,0,0-.36,1A.76.76,0,0,0,284,41a.75.75,0,0,0,.57,0,9.7,9.7,0,0,0,5-5.16,8.65,8.65,0,0,0-.14-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M276.9,22.93a8.48,8.48,0,0,0-3.13,1.64,8.72,8.72,0,0,0-2.22,2.75,9.69,9.69,0,0,0-.7,7.11.87.87,0,0,0,.26.39.78.78,0,0,0,.44.15.76.76,0,0,0,.21,0,.7.7,0,0,0,.44-.35.73.73,0,0,0,.07-.56,8.15,8.15,0,0,1,.58-6,7.23,7.23,0,0,1,4.45-3.65.74.74,0,0,0,.45-.35.71.71,0,0,0,.09-.28.67.67,0,0,0,0-.28.64.64,0,0,0-.13-.26.67.67,0,0,0-.22-.19,1.22,1.22,0,0,0-.27-.09.7.7,0,0,0-.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M301,50.15l-7.69-8.67a16.12,16.12,0,0,0-1.06-20,16.15,16.15,0,1,0-13.11,26.79l1,0a16.1,16.1,0,0,0,7.66-1.93L295.54,55a2.93,2.93,0,0,0,2,1,3,3,0,0,0,2.15-.73l1-.92a3,3,0,0,0,1-2A3,3,0,0,0,301,50.15ZM279.45,43.8a11.7,11.7,0,1,1,12.34-13.24,11.57,11.57,0,0,1-1.08,6.7,11.73,11.73,0,0,1-11.26,6.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 35.61,
    cy: 324.61,
    r: 35.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M26,326.67A8.33,8.33,0,1,0,34.33,335,8.32,8.32,0,0,0,26,326.67Zm-3.4,4.93H26a1.14,1.14,0,0,1,0,2.27H22.6a1.14,1.14,0,0,1,0-2.27Zm6.8,6.8H22.6a1.14,1.14,0,0,1,0-2.27h6.82a1.14,1.14,0,0,1,1.13,1.14A1.15,1.15,0,0,1,29.4,338.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M44.33,310H27.67c-5,0-8.34,2.5-8.34,8.33v5.24a1.67,1.67,0,0,0,2.37,1.5,10.81,10.81,0,0,1,15,11.43,1.66,1.66,0,0,0,1.65,1.85h5.95c5,0,8.34-2.5,8.34-8.33V318.33C52.67,312.5,49.33,310,44.33,310Zm.79,9.32-5.22,4.16a6.42,6.42,0,0,1-7.8,0l-5.22-4.16a1.3,1.3,0,0,1-.2-1.77,1.25,1.25,0,0,1,1.75-.2l5.22,4.17a4,4,0,0,0,4.68,0l5.22-4.17a1.23,1.23,0,0,1,1.75.2A1.28,1.28,0,0,1,45.12,319.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.108642c14b0edd6ad08c992f4135feca.svg";
export { ForwardRef as ReactComponent };